import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import Layout from '@/components/Layout';
import CaseStudiesListPage from '@/pages/CaseStudiesListPage';
import CaseStudyEditorPage from '@/pages/CaseStudyEditorPage';
import ArticlesListPage from '@/pages/ArticlesListPage';
import ArticleEditorPage from '@/pages/ArticleEditorPage';

function AppRoutes() {
  const { token, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <span className="text-zinc-500 text-sm">Loading…</span>
      </div>
    );
  }

  if (!token) return <LoginPage />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="case-studies"          element={<CaseStudiesListPage />} />
        <Route path="case-studies/new"      element={<CaseStudyEditorPage />} />
        <Route path="case-studies/:id/edit" element={<CaseStudyEditorPage />} />
        <Route path="articles"              element={<ArticlesListPage />} />
        <Route path="articles/new"          element={<ArticleEditorPage />} />
        <Route path="articles/:id/edit"     element={<ArticleEditorPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
